<app-header [label]="page_name | plural"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <app-search-input #searchbar></app-search-input>
    <div class="flex gap-2">
        <app-button *ngIf="gs.user_role_data?.evaluation_management_assessments_add" color="bg-secondary text-[#310000]"
            [label]="page_name" icon="bx bx-plus" routerLink="/assessment/form"
            routerLinkActive="router-link-active"></app-button>
    </div>
</div>
<app-ag-grid-list [list]="items" [colDefs]="assessment_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)"
    (bulkDelete)="bulk_delete($event)">
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true"
    cancelText="CANCEL" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="YES" [is_mandatory]="true"
    (confirm_modal_clicked)="delete_university()" (close_modal_clicked)="confirmation_delete_modal.close()">
    Are you sure you want to Delete Assessment.
</app-confirmation-popup>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
    <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5"
        [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>